/**
 * 用户登录相关
 */
import store from './localStore'

const UserKey = 'auth_user'
const UserIdKey = 'auth_user_id'
const TokenKey = 'auth_token'
const HomeKey = 'home_path'

export function isAuthenticated () {
  return !!store.getItem(UserKey)
}

export function getUserId () {
  return store.getItem(UserIdKey, false)
  // return '1eb217bf-f1bd-49bd-b893-4ca594ddbc22'
}

export function setUserId (userId) {
  store.setItem(UserIdKey, userId)
}

export function setUser (user) {
  store.setItem(UserKey, user)
  // store.setItem(Token, user.bearerToken)
}

export function getUser () {
  return store.getItem(UserKey)
}

export function getToken () {
  return store.getItem(TokenKey, false)
  // return 'fxtn4EEX0Nx1Q3cLiNdqHYmw4+BM4qevBgGip0qkd45RuqMJ+U4B0wb7MwSBTzkvpSegvK4lCfd1nMCyoQqQjG7KVzUGtB/qQksorW7D1Vza/3DSYFEURrFB+xIKpCG0s8vcgAlbxLdC6YPY7s8goJeC+SU7j8WGRIOtCajIpRavubsdEQrMPZAya5KSFpgM+E3UYdgjisXpGD1Bzk3tyhTKb1navkZvcKAaUoKbgIybK7EefrabyH01VgcrYcoNISP6CpS3We4z08IqRKs2ta2lq6lpXq7gOTlLnirRDMkGNen/cb0y91mM0Bv37jKzzJ4IqCaiFLrzCtZidLa+4g=='
}

export function setToken (token) {
  store.setItem(TokenKey, token)
}

export function clearAuth () {
  store.removeItem(UserKey)
  store.removeItem(TokenKey)
  store.removeItem(HomeKey)
  store.removeItem(UserIdKey)
}
